import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {UtilityService} from "../../core/services/utility.service";

@Component({
  selector: 'app-pagination-table',
  templateUrl: './pagination-table.component.html',
  styleUrls: ['./pagination-table.component.scss']
})
export class PaginationTableComponent implements OnInit {
  @Input() isLoading = false;
  @Input() totalRegistros = 10;
  @Input() pagina: number = 1;
  @Input() registros = 10;
  @Output() pageChangeTableEvent = new EventEmitter<number>();


  constructor(public utilityService: UtilityService) { }

  ngOnInit(): void {

  }

  pageChangeTable(event: any){
    this.pageChangeTableEvent.emit(event);
  }


}
